export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Checkmark</title>
    <path
      d="m4.31 17.323 9.72 8.394L29.5 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
